import React, { useEffect, useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { red } from '@mui/material/colors';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Divider from '@mui/material/Divider';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CreateOppModal from '../components/opportunities/CreateOppModal';

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  
  return <IconButton {...other} />;
})(({ theme }) => ({
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
  variants: [
    {
      props: ({ expand }) => !expand,
      style: {
        transform: 'rotate(0deg)',
      },
    },
    {
      props: ({ expand }) => !!expand,
      style: {
        transform: 'rotate(180deg)',
      },
    },
  ],
}));

const OppCard = props => {
  const [expanded, setExpanded] = React.useState(false);
  const navigate = useNavigate();
    console.log(props.opp)
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  

  const [createModalState, setCreateModalState] = useState(false);
  const [oppToEdit, setOppToEdit] = useState(null);

  useEffect(() => {
      if(oppToEdit == null) return;
  
      setCreateModalState('edit');
    }, [oppToEdit]);

  useEffect(() => {
    if(createModalState === '') setOppToEdit(null);
  }, [createModalState]);
  return (
    <>
    {createModalState && <CreateOppModal createModalState={createModalState} setCreateModalState={setCreateModalState} oppToEdit={oppToEdit}/>}
    
    <Card sx={{display: 'flex', flexDirection: 'column', width: { xs: '100%', sm: '48%', md: '18vw' }, padding: '0.5%', marginBottom:'1vh', marginRight:'1vw', boxShadow:'2px 6px 12px rgb(164, 164, 164)'}}>
      <CardContent>
        <Typography variant="h5" component="div" style={{ textAlign: "center", color: "rgb(8,114,182)"}} onClick={() => {
                // navigate(`/opportunities/${props.opp.id}`)
            }}>{props.opp.name}</Typography>
            <br/>
          <Box sx={{display: "flex", justifyContent: "center", gap: 5, mb: 1,}}>
              <Typography style={{color: "rgb(78,79,83)"}}><strong>Category:</strong> {props.opp.category}</Typography>
              <Typography style={{color: "rgb(78,79,83)"}}><strong>Status:</strong> {props.opp.status}</Typography>
          </Box>
      </CardContent>

      <CardActions disableSpacing>
        <ExpandMore expand={expanded} onClick={handleExpandClick} aria-expanded={expanded} aria-label="show more">
          <ExpandMoreIcon />
        </ExpandMore>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>    
        <CardContent>
            <Box sx={{display: "flex", justifyContent: "center", gap: 5, mb: 2,}}>
                <Typography><strong>Potential Savings ($/yr):</strong> ${Math.round(props.opp.savings).toLocaleString()}</Typography>
                <Typography><strong>GHG Savings (MT/yr):</strong> ${Math.round(props.opp.ghg).toLocaleString()}</Typography>
            </Box>
            <Box sx={{display: "flex", justifyContent: "center", gap: 5, mb: 2,}}>
                <Typography><strong>Implementation Cost ($/yr):</strong> ${Math.round(props.opp.cost).toLocaleString()}</Typography>
                <Typography><strong>Payback (years):</strong> {Number(props.opp.payback).toFixed(2)}</Typography>
            </Box>
            <Box sx={{display: "flex", justifyContent: "center", gap: 5, mb: 2,}}>
              <Typography>
                <strong>Start Date:</strong>{" "}
                {props.opp.start === "TBD"
                  ? "TBD"
                  : new Date(Number(props.opp.start)).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
              </Typography>
              <Typography>
                <strong>Start Date:</strong>{" "}
                {props.opp.start === "TBD"
                  ? "TBD"
                  : new Date(Number(props.opp.end)).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
              </Typography>
            </Box>
            
            <Divider style={{margin:'3% 0 4% 0'}}/>

            <Box sx={{display: "flex", justifyContent: "center", gap: 5, mb: 2,}}>
                <Typography className="text-brand" onClick={() => {
                        // props.setOppToDelete(row);
                        
                        setOppToEdit(props.opp);
                      }}
                    >Edit Opportunity</Typography>
                <Typography style={{color:'#dc3545'}}>Delete Opportunity</Typography>
            </Box>
        </CardContent>
      </Collapse>
    </Card>
    </>
  );
}

export default OppCard;
